import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { phoneModalTypes as Type } from '../../types/phone-modal';
import { userTypes } from '../../types/user';

const INITIAL_STATE = {
  isPhoneModalDismissed: false,
  /** True after at least one successful phone-prompt GET for the current user id. */
  phonePromptLoaded: false,
  phonePromptUserId: null as string | null,
  /** Mirrors GET /user/phone-prompt has_seen_phone_prompt */
  hasSeenPhonePrompt: null as boolean | null,
};

const phoneModalReducer = (state = INITIAL_STATE, action: any) => {
  switch (action.type) {
    case Type.SET_PHONE_MODAL_DISMISSED:
      return {
        ...state,
        isPhoneModalDismissed: true,
      };
    case Type.PHONE_PROMPT_FETCH_SUCCESS:
      return {
        ...state,
        phonePromptLoaded: true,
        phonePromptUserId: action.payload.userId,
        hasSeenPhonePrompt: action.payload.has_seen_phone_prompt,
      };
    case Type.RESET_PHONE_MODAL:
    case userTypes.USER_LOGOUT:
      return {
        ...INITIAL_STATE,
      };
    default:
      return state;
  }
};

const phoneModalPersistConfig = {
  key: 'phoneModal',
  storage,
  // Keep "Ask later" across refresh; always refetch has_seen from the server.
  whitelist: ['isPhoneModalDismissed'],
};

export default persistReducer(phoneModalPersistConfig, phoneModalReducer);

